<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-classevaluate__evaluate-ranked">
      <el-form :model="dataForm">

        <el-form-item label="学期" prop="id">
          <el-select v-model="dataForm.termId">
            <el-option v-for="term in this.termList.list" :key="term.id" :value="term.id" :label="term.termName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getTermEvaluate()">{{ $t('query') }}</el-button>
          <el-button type="primary" @click="exportExcel2()">{{ $t('export') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="dataList" border style="width: 100%;":default-sort = "{prop: '总分', order: 'null'}">
        <el-table-column prop="className" label="班级" header-align="center" align="center">
        </el-table-column>
        <el-table-column :prop="item" v-for="(item,index) in typeList" :key="index" :label="item"
                         header-align="center" align="center"></el-table-column>
        <el-table-column prop="total" label="总分" header-align="center" align="center" sortable></el-table-column>
        <el-table-column prop="addSore" label="是否获“五星班级”" header-align="center" align="center"></el-table-column>
        <el-table-column prop="className" label="班级" header-align="center" align="center">
        </el-table-column>
         </el-table>
    </div>
  </el-card>
</template>

<script>
import Blob from '../../../vendor/Blob'
import Export2Excel from '../../../vendor/Export2Excel'

export default {
  data () {
    return {
      domains: [{
        rollCallDate: []
      }],
      dataForm: {
        termId: '',
        termName: ''
      },
      typeList: [],
      termList: [],
      dataList: []
    }
  },
  mounted () {
    this.getTerm()
    this.getTermEvaluate()
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!')
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getTerm () {
      this.$http.get('term/term/page').then(({ data: res }) => {
        this.termList = res.data
        console.log(this.termList)
      })
    },
    removeDomain (item) {
      var index = this.domains.indexOf(item)
      if (index !== -1) {
        this.domains.splice(index, 1)
      }
    },
    addDomain () {
      this.domains.push({
      })
    },
    getTermEvaluate () {
      console.log(this.dataForm)
      this.$http.post('classEvaluate/evaluateScore/term/report', this.dataForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataList = res.data

        for (let i = 0; i < this.dataList[this.dataList.length - 1].weeks.length; i++) {
          this.typeList.push('第' + (i + 1) + '周')
        }
      }).catch(() => {
      })
    },

    formatJson (filterVal, jsonData) {
      return jsonData.map(v => {
        return filterVal.map(j => v[j])
      })
    },
    exportExcel2 () {
      // 写在需要执行的方法下面
      import('../../../vendor/Export2Excel').then((excel) => {
        const schoolName = this.dataList[0].schoolName
        const termName = this.dataList[0].termName
        const multiHeader2 = [
          schoolName + '“五星班级”学期评比栏', '', '', ''
        ] // 导出的表头名
        const header = [
          '班级'
        ]
        const multiHeader = [
          termName
        ] // 导出的表头名
        const filterVal = [
          'className'
        ] // 导出的表头字段名

        this.typeList.forEach(s => {
          multiHeader2.push('')
          multiHeader.push('')
          header.push(s)
          filterVal.push(s)
        })
        // multiHeader.push('第  月')
        header.push('总分')
        header.push('是否获“五星班级”')
        filterVal.push('total')
        filterVal.push('')
        header.push('班级')
        filterVal.push('className')
        const merges = [
          'A1:W1',
          'A2:W2'
        ] // 根据Excel确定要合并的单元格
        const list = this.dataList // 把data里的tableData存到list
        const data = this.formatJson(filterVal, list)
        const filterName = schoolName + '学“五星班级”学期评比栏'
        excel.export_json_to_excel2({
          multiHeader, // 这里是第二行的表头
          multiHeader2, // 这里是第一行的表头
          header, // 这里应该是算第三行的表头
          data,
          merges,
          filename: filterName
        })
      })
    }
  }
}
</script>
